import React, { useState } from 'react';
import NewResultHeading from '../NewResultHeading';
import NewResultTabButtons from '../NewResultTabButtons';
import NewResultFilterSection from '../NewResultFilterSection';
import NewResultContent from '../NewResultContent';

// 버튼 라벨과 game_type 매핑
const gameTypeMap = {
  스포츠: 'sports',
  '실시간 스포츠': 'live_sports',
  카지노: 'casino',
  슬롯: 'slot',
  미니게임: 'minigame',
  가상게임: 'virtual',
  홀덤: 'holdem',
  로투스: 'lotus',
  크라운: 'crown',
  MGM: 'mgm',
};

const NewResult = () => {
  // 기본값: 미니게임
  const [gameType, setGameType] = useState('minigame');

  // 버튼 클릭 시 라벨을 받아서 game_type으로 변환
  const handleTabChange = (label) => {
    setGameType(gameTypeMap[label] || 'minigame');
  };

  return (
    <>
      <div className="bg-[#0e0e0f] lg:space-y-8 p-2.5  pb-0 lg:px-4 lg:pb-2.5 lg:pt-[25px] ">
        <NewResultHeading />
        <NewResultTabButtons onTabChange={handleTabChange} />
        <NewResultFilterSection />
        <NewResultContent gameType={gameType} />
      </div>
    </>
  );
};

export default NewResult;
